import { render, staticRenderFns } from "./ConsentForm.vue?vue&type=template&id=162cb828"
import script from "./ConsentForm.vue?vue&type=script&lang=js"
export * from "./ConsentForm.vue?vue&type=script&lang=js"
import style0 from "./ConsentForm.vue?vue&type=style&index=0&id=162cb828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports